(() => {
  'use strict';

  const initializeProduct = (root) => {
    if (root.dataset.hatchProductReady === 'true') return;
    root.dataset.hatchProductReady = 'true';

    const track = root.querySelector('[data-hatch-gallery-track]');
    const slides = Array.from(root.querySelectorAll('[data-hatch-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-us-gallery-button]'));
    const dotGroup = root.querySelector('[data-hatch-gallery-dots]');
    const galleryStatus = root.querySelector('[data-us-gallery-status]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let currentIndex = 0;
    let scrollFrame = 0;

    const setCurrent = (index, announce) => {
      const previousIndex = currentIndex;
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-pressed', String(dotIndex === currentIndex));
      });
      if (announce && (previousIndex !== currentIndex || !galleryStatus?.textContent) && galleryStatus && slides[currentIndex]) {
        const description = slides[currentIndex].querySelector('img')?.alt || 'Product photo';
        galleryStatus.textContent = `${currentIndex + 1} of ${slides.length}: ${description}`;
      }
    };

    const showSlide = (index, announce = true, smooth = true) => {
      if (!track || !slides[index]) return;
      setCurrent(index, announce);
      if (mobile.matches) {
        track.scrollTo({
          left: index * track.clientWidth,
          behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto'
        });
      } else {
        slides.forEach((slide, slideIndex) => {
          slide.toggleAttribute('data-hatch-featured', slideIndex === index);
          const photo = slide.querySelector('img');
          if (photo) {
            photo.toggleAttribute('data-us-main-image', slideIndex === index);
            if (photo.srcset) photo.sizes = slideIndex === index ? '(max-width: 1440px) 60vw, 860px' : '(max-width: 1440px) 30vw, 430px';
          }
        });
      }
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));
    if (dotGroup && dots.length === slides.length) dotGroup.hidden = false;

    if (track) {
      track.addEventListener('scroll', () => {
        if (!mobile.matches || scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = 0;
          if (track.clientWidth) setCurrent(Math.round(track.scrollLeft / track.clientWidth), true);
        });
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (!mobile.matches || event.target !== track) return;
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex += 1;
        else if (event.key === 'ArrowLeft') nextIndex -= 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = slides.length - 1;
        else return;
        event.preventDefault();
        showSlide(Math.max(0, Math.min(nextIndex, slides.length - 1)));
      });
    }

    mobile.addEventListener('change', () => {
      if (!root.isConnected) return;
      slides.forEach((slide) => {
        const photo = slide.querySelector('img');
        if (mobile.matches && photo?.srcset) photo.sizes = '100vw';
      });
      showSlide(currentIndex, false, false);
    });

    const primaryVariant = root.querySelector('[data-us-primary-variant]');
    if (!primaryVariant) return;

    const variantSelectors = Array.from(root.querySelectorAll('[data-us-variant]'));
    const prices = Array.from(root.querySelectorAll('[data-us-price]'));
    const addButtons = Array.from(root.querySelectorAll('[data-us-add]'));
    const stockStatus = root.querySelector('[data-us-stock]');

    const selectVariant = (variantId, updateImage) => {
      const option = Array.from(primaryVariant.options).find((item) => item.value === variantId);
      if (!option) return;
      variantSelectors.forEach((selector) => { selector.value = variantId; });
      const available = option.dataset.available === 'true';
      prices.forEach((price) => { price.textContent = option.dataset.price || ''; });
      addButtons.forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      });
      if (stockStatus) stockStatus.textContent = available ? '' : 'This option is currently sold out.';

      if (updateImage && option.dataset.featuredMediaId) {
        const imageIndex = slides.findIndex((slide) => slide.dataset.mediaId === option.dataset.featuredMediaId);
        if (imageIndex !== -1) showSlide(imageIndex, false, false);
      }
    };

    variantSelectors.forEach((selector) => {
      selector.addEventListener('change', () => selectVariant(selector.value, true));
    });
    selectVariant(primaryVariant.value, true);
  };

  const initialize = (scope) => {
    if (scope.matches?.('[data-us-hatch-product]')) initializeProduct(scope);
    scope.querySelectorAll('[data-us-hatch-product]').forEach(initializeProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
